import React, { FC, ReactNode } from 'react';

import AlertMessage from './AlertMessage';
import s from './FieldWrapper.module.scss';

type FieldWrapperProps = {
  children: ReactNode;
  error?: ReactNode;
  warning?: ReactNode;
  touched?: boolean;
  label?: ReactNode;
  id: string;
  rootClassName?: string;
  errorClassName?: string;
  warningClassName?: string;
  labelClassName?: string;
  shouldBeTouchedToShowError?: boolean;
};

const FieldWrapper: FC<FieldWrapperProps> = ({
  id,
  children,
  label,
  touched,
  error,
  warning,
  rootClassName = s.root,
  errorClassName = s.error,
  labelClassName = s.label,
  warningClassName = s.warning,
  shouldBeTouchedToShowError,
}) => (
  <div className={rootClassName}>
    {label && (
      <label
        htmlFor={id}
        className={labelClassName}
      >
        {label}
      </label>
    )}
    {children}
    {!!(error || warning) && (
      <AlertMessage
        error={error}
        errorClassName={errorClassName}
        warning={warning}
        warningClassName={warningClassName}
        touched={touched}
        shouldBeTouchedToShowError={shouldBeTouchedToShowError}
        withIcon
      />
    )}
  </div>
);

export default FieldWrapper;
